<script setup>
import { useUserStore } from "@/store/user-store";
import { computed } from "vue";

const store = useUserStore();
const user = computed(() => store.getuserData);

// Map internal tab names to user-friendly display names
const getDisplayTabName = (tabName) => {
  const tabNameMap = {
    'ManageProfile': 'Complete Your Profile',
    'Dashboard': 'Dashboard',
    'My Goals': 'My Goals',
    'MyModelPortfolio': 'Model Portfolio',
    'Stock Screener': 'Top Screeners. Timeless Strategies. Smarter Decisions',
    'Mutual Fund Recommender': 'Mutual Fund Recommender',
    'Stock Analysis': 'Stock Analysis',
    'Portfolio Analytics': 'Portfolio Insights & Analytics Dashboard',
    'Planning Tools': 'Financial Planning Calculators',
    'Blogs & videos': 'Blogs & Videos',
    'Quaterly Results': 'Quarterly Results',
    'Monthly Market Update': 'Monthly Market Update',
    'Contact Us': 'Contact Us'
  };

  return tabNameMap[tabName] || tabName;
};
</script>

<template>
  <div
    class="section-header d-flex justify-between align-items-center pb-15 w-100"
  >
    <div class="header-left d-flex align-items-center gap-15">
      <span class="font-30 font-weight-700">{{ getDisplayTabName(store.userTab) }}</span>
      <!-- Slot for custom actions (e.g., Portfolio Commentary button) -->
      <slot name="actions"></slot>
    </div>
    <div class="d-flex gap-10">
      <i class="pi pi-user icon" />
      <div class="d-flex flex-direction-column">
        <span class="font-15 font-weight-500">{{ user?.username }}</span>
        <span class="font-15 font-weight-400">{{ user?.email }}</span>
      </div>
    </div>
  </div>
</template>

<style>
.section-header {
  border-bottom: 1px solid var(--an-gray1);
}

.header-left {
  flex: 1;
}

.icon {
  width: 50px;
  border-radius: 100%;
  background: var(--an-background-light);
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
